import React from 'react';
import { styled } from '@compiled/react';
import { Label } from '@atlaskit/form';
import { token } from '@atlaskit/tokens';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { DatePickerReadView } from '../../../common/ui/version-dates/DatePickerReadView.tsx';
import type {
	EditableDatePicker,
	Props as EditableDatePickerProps,
} from './EditableDatePicker.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyEditableDatePicker = lazy<typeof EditableDatePicker>(() =>
	import(/* webpackChunkName: "async-editable-date-picker" */ './EditableDatePicker.tsx').then(
		(module) => module.EditableDatePicker,
	),
);

export const AsyncEditableDatePicker = (props: EditableDatePickerProps) => (
	<Placeholder
		name="editable-date-picker"
		fallback={
			<SkeletonContainer>
				<Label htmlFor="version-details-editable-date-picker">{props.label}</Label>
				<InlineEditReadViewContainer>
					<DatePickerReadView displayDate={props.displayDate} />
				</InlineEditReadViewContainer>
			</SkeletonContainer>
		}
	>
		<LazyEditableDatePicker {...props} />
	</Placeholder>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SkeletonContainer = styled.div({
	minWidth: '160px',
	marginBottom: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const InlineEditReadViewContainer = styled.div({
	borderWidth: '2px',
	borderStyle: 'solid',
	borderColor: 'transparent',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	lineHeight: 1,
});
